/**
 * @generated SignedSource<<58b99bdcf55c233612ce6ad2d6435647>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserRole = "CLIENT" | "COACH" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserDetails_user$data = {
  readonly admin: boolean;
  readonly email: string | null | undefined;
  readonly id: string;
  readonly role: UserRole;
  readonly trialExpiryDate: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateTrialExpirationDateDialog_user">;
  readonly " $fragmentType": "UserDetails_user";
};
export type UserDetails_user$key = {
  readonly " $data"?: UserDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "admin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "raw",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "trialExpiryDate",
      "storageKey": "trialExpiryDate(raw:true)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateTrialExpirationDateDialog_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bb49ecf31c5f7134fcd29d249d2d4b38";

export default node;
